import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.8303 18.7803C14.5374 19.0732 14.0626 19.0732 13.7697 18.7803L7.76966 12.7803C7.47676 12.4874 7.47676 12.0126 7.76966 11.7197L13.7697 5.71967C14.0626 5.42678 14.5374 5.42678 14.8303 5.71967C15.1232 6.01256 15.1232 6.48744 14.8303 6.78033L9.36065 12.25L14.8303 17.7197C15.1232 18.0126 15.1232 18.4874 14.8303 18.7803Z",
		fill: "currentColor"
	})
});
export { SvgIconChevronBack as ReactComponent };
